<template>
  <div class="chatHistoryBox">
    <div class="title">
      <h2>你的AI助手</h2>
    </div>
    <div class="talksBox scrollStyle" ref="talksRef">
      <div v-for="(item, index) in chatList" :key="item.id" @click="startChat(item)">
        <Msg 
          :news="item" 
          msgType="chat"
          :itemKey="{
            avatar: 'avatarFileUrl',
            textTitle: 'name',
            textContent: 'describe',
          }"
        >
        </Msg>
      </div>
      <!-- <div @click="changeAiAssistantId(null)">ceshi</div> -->
    </div>
  </div>
</template>

<script>
import api from '@/api';
import Msg from '../+components/Msg';
import {mapState, mapMutations} from 'vuex';

export default {
  name: 'ChatHistory',
  components: {Msg},
  props: {},
  data () {
    return {
      GetAiassistantList: api.GetAiassistantList,
      chatList: [],
      loadingInstance: false,
      // msgList: [
      //   {
      //     avatar: require('@/assets/chatImg/user-9.png'),
      //     textTitle: '捷捷AI',
      //     textContent: '新一代智能人机交互问答引擎，为用户提供更优质的体验',
      //   },
      //   {
      //     avatar: require('@/assets/chatImg/a1.jpg'),
      //     textTitle: 'AI绘图',
      //     textContent: '一句话即可生成图片，支持多种风格，快来试试看',
      //   },
      //   {
      //     avatar: require('@/assets/chatImg/a2.jpg'),
      //     textTitle: '星座运势',
      //     textContent: '今日我将为你揭开星座的神秘面纱，告诉你未来的运势。',
      //   },
      // ],
    }
  },
  computed: {
    ...mapState('userAbout', ['user']),
  },
  watch: {},
  created () {},
  mounted () {
    this.getChatList();
  },
  methods: {
    ...mapMutations('userAbout', ['changeAiAssistantId', 'changeAiAssistant']),
    startChat(item) {
      // console.log(item, '聊天');
      this.$emit('goChat');
      //1.TextToText;2.ImageToText;3.TextToImage;4.TextToSpeech;
      this.changeAiAssistantId(item.id);
      this.changeAiAssistant(item);
    },
    // 获取AI助手列表
    getChatList() {
      const talksRef = this.$refs.talksRef;
      this.loadingInstance = this.$loading({
        target: talksRef,
      })
      // const params = {
      //   AvatarFile: this.user.avatarFile,
      //   Name: this.user.account,
      //   session: this.user.session
      // };
      // this.GetAiassistantList(params).then((res) => {
      this.GetAiassistantList().then((res) => {
        this.loadingInstance.close();
        this.chatList = res.data?.map(item => {
          return {
            ...item,
            avatar: item.avatarFileUrl,
            textTitle: item.name,
            textContent: item.describe,
          }
        });
      })
    }
  }
}
</script>

<style scoped lang="less">
.chatHistoryBox {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  .title {
    line-height: 24px;
    margin: 16px 0 8px;
    height: 22px;
    h2 {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .talksBox {
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
